import api from './api';

/**
 * Extract file UUID from POST /v1/tenant/file/create response body.
 * The API nests the uuid at body.file.uuid (not body.file_uuid).
 */
export const getFileUuidFromCreateResponse = (body) => {
  if (!body) return null;
  return (
    body?.file?.uuid ??
    body?.uuid ??
    body?.file_uuid ??
    body?.fileUuid ??
    null
  );
};

export const getUploadUrlFromCreateResponse = (body) => {
  if (!body) return null;
  return body?.uploadUrl ?? body?.upload_url ?? null;
};

export const createFile = async (body) => {
  const response = await api.post(`/v1/tenant/file/create`, body);
  return response;
};  


export const getFile = async (id, body) => {
  const response = await api.get(`/v1/file/${id}`, { data: body });
  return response.data;
};


export const softDeleteFile = async (id, body) => {
  const response = await api.post(`/v1/file/${id}`, body);
  return response.data;
};


export const hardDeleteFile = async (id, body) => {
  const response = await api.post(`/v1/file/purge/${id}`, body);
  return response.data;
};


export const updateFile = async (body) => {
  const response = await api.post(`/v1/file/update`, body);
  return response.data;
};


export const listFiles = async (body) => {
  const response = await api.post(`/v1/file/list`, body);
  return response.data;
};


export const getUploadUrl = async (body) => {
  const response = await api.post(`/v1/file/upload-url`, body);
  return response.data;
};


export const getContactFiles = async (body) => {
  const response = await api.post(`/v1/file/contact-files`, body);
  return response.data;
};


export const generateAvatar = async (body) => {
  const response = await api.post(`/v1/file/generate-avatar`, body);
  return response.data;
};


export const validateContactSchema = async (body) => {
  const response = await api.post(`/v1/file/validate-contact-schema`, body);
  return response.data;
};
